import Badge from '@components/Badge';
import Column from '@components/Column';
import Text from '@components/Text';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { OrderRow } from '@models/order/orderLog';
import { OrderStatusBadgeColor } from '@models/order/orderLog/extension';
import { Link } from '@stackflow/link';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
    order: OrderRow;
}

function OrderLog({ order }: Props) {
    const { t } = useTranslation('orderLogs');
    const {
        status, shopName, orderName, optionSummary, createdAt, orderNo, shopOrderNo, orderType,
        displayOrderNo,
    } = order;
    return (
        <Link activityName='OrderLogActivity'
            activityParams={{ orderNo }}
            css={[pressActionEffect, wrapperCss]} >
            <Container fullWidth>
                <Body spacing={3}
                    fullWidth >
                    <Badge color={OrderStatusBadgeColor[status]}>
                        {t(`status.${status}`)}
                    </Badge>
                    <Text fontWeight='bold' size='title' ellipsis>{shopName}</Text>
                    <Text color='var(--color-text-secondary)' ellipsis>
                        {t(`orderType.${orderType}`)} {(displayOrderNo || `${shopOrderNo}`).padStart(4, '0')} ·
                      &nbsp;{orderName} {optionSummary}
                    </Text>
                </Body>
                <Footer>
                    <Text color='var(--color-text-secondary)' align='center'>
                        {dayjs(createdAt).format('YYYY.MM.DD')}
                    </Text>
                </Footer>
            </Container>
        </Link>
    );
}

const wrapperCss = css`
    width: 100%;
`;

const Container = styled(Column)`
    background-color: var(--color-white);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    overflow: hidden;
`;

const Body = styled(Column)`
    padding: var(--spacing-4);
    overflow: hidden;
`;

const Footer = styled.div`
    border-top: 1px solid var(--color-border-default);
    padding: var(--spacing-2) 0;
    text-align: center;
    width: 100%;
`;

export default OrderLog;
